import { LastWriteWinsConsistencySchema, } from "@referee-fyi/consistency";
import { z } from "zod/v4";
import { IncidentMatchHeadToHeadSchema } from "./incident.js";
export const BaseMatchScratchpadSchema = z.looseObject({
    id: z.string(),
    event: z.string(),
    match: IncidentMatchHeadToHeadSchema,
    notes: z.string().optional(),
});
export const SCRATCHPAD_IGNORE = ["event", "match", "notes", "id"];
export const MatchScratchpadSchema = BaseMatchScratchpadSchema.extend({
    consistency: LastWriteWinsConsistencySchema(z.string()),
}).meta({
    id: "MatchScratchpad",
    description: "Real-time information about a match recorded by a head referee.",
});
//# sourceMappingURL=scratchpad.js.map